module.exports = __webpack_public_path__ + "img/ring_of_health.f6b48157.png";